import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { setupIonicReact } from '@ionic/react'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { Provider } from 'react-redux'
import store from './redux/store/'

// eslint-disable-next-line no-unused-vars
import * as timeAgoConfig from './settings/timeAgoConfig'
import { installAuthInterceptor, cleanStaleAuthData } from './services/authGuard'
import { bootStep, reportPreviousBoot } from './services/diag'
import { installOverlayDiag } from './services/overlayDiag'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

/* Fonts */
// import './settings/theme/fonts.min.css'

/* Theme variables */
import './settings/theme/variables.min.css'

/* styles globals */
import './settings/theme/globalStyles.scss'

setupIonicReact()

reportPreviousBoot() // DIAG: report where the previous session stopped (if it froze)
bootStep('react_eval') // DIAG
installOverlayDiag() // DIAG: watch for stuck/orphaned overlay backdrops on resume

// Clean stale auth data BEFORE anything renders (env mismatch, expired tokens)
cleanStaleAuthData()
bootStep('auth_cleaned') // DIAG

// Global 401/403 interceptor — any API call returning unauthorized
// clears auth data and redirects to /login
installAuthInterceptor()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<Provider store={store}>
		{/* <StrictMode> */}
		<App />
		{/* </StrictMode> */}
	</Provider>
)
bootStep('render_called') // DIAG

// Check if service workers are supported and we're not on iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
const isServiceWorkerSupported = 'serviceWorker' in navigator

if (isServiceWorkerSupported && !isIOS) {
	serviceWorkerRegistration.register()
} else {
	console.log('Service Worker not supported or running on iOS')
}
